import React, { useEffect, useState } from "react";
import "./datatable.scss";
import { Space, Input, Button, Image, Tag, Popover } from "antd";
import type { ColumnsType } from "antd/es/table";
import { EditOutlined, DeleteOutlined, LinkOutlined } from "@ant-design/icons";
import moment from "moment";
import { AppTable } from "../common";

interface Contentdata {
  key?: string;
  _id: number;
  id?: number;
  title: string;
  type: string;
  contend: string;
  link: string;
  image: string;
  sheduledDate: string;
}
// interface DataTableProps {
//     setshowModel: (value: boolean) => void,
//     setEditable: (value: boolean) => void,
//     deleteThought: (value: any) => void,
//     editContent:(value:any)=>void
//     isOpen: boolean,
//     contentData?: Contentdata[]
// }
function DataTableOtherContent({
  setshowModel,
  setEditable,
  isOpen,
  contentData,
  deleteOtherContent,
  editContent,
  showModal,
}: any) {
  const [searchText, setSearchText] = useState("");
  const [contentType, setContentType] = useState<any>();

  useEffect(() => {
    contentData &&
      contentData.map((data: any) => {
        setContentType(data.type);
      });
  }, [contentData]);

  useEffect(() => {
    console.log(contentType, "sdsds");
  }, [contentType]);

  const columns: ColumnsType<Contentdata> = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "_id",
      width: 80,
      filteredValue: [searchText],
      defaultSortOrder: "descend",
      sorter: (a, b) => (a._id || a.id || 0) - (b._id || b.id || 0),
      onFilter: (value, record) => {
        return (
          String(record.title).toLowerCase().includes(value.toLocaleString()) ||
          String(record._id || record.id).toLowerCase().includes(value.toLocaleString()) ||
          String(record.contend).toLowerCase().includes(value.toLocaleString())
        );
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Content",
      dataIndex: "contend",
      key: "contend",
      render: (text) => (
        <>
          <p dangerouslySetInnerHTML={{ __html: text?.slice(0, 100) }} />
        </>
      ),
    },
    {
      title: "Link",
      dataIndex: "link",
      key: "link",
      // width: 90,
      render: (_, record) => (
        <Space size="middle">
          <a
            className="table_pill_btn table_pill_btn--view"
            href={record?.link}
            target="_blank"
            rel="noreferrer"
          >
            <LinkOutlined /> Click
          </a>
        </Space>
      ),
    },
    ...(contentType === "crisis"
      ? []
      : [
          {
            title: "Image",
            dataIndex: "image",
            key: "image",
            render: (_: any, record: any) => (
              <Space size="middle">
                <Image src={record?.image} width={60} height={60} alt={"image"} />
              </Space>
            ),
          },
        ]),
       {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => <div>{moment(text).format("DD-MM-YYYY hh:mm A")}</div>,
    },
    {
      title: "Status",
      dataIndex: "sheduledDate",
      key: "sheduledDate",
      // width: 90,
      render: (_, record) => (
        <Space size="middle">
          {record.sheduledDate === null ? (
            <Tag color={"green"}>Published</Tag>
          ) : moment().format("YYYY-MM-DD") >= record.sheduledDate ? (
            <Tag color={"green"}>Published</Tag>
          ) : (
            <Tag color={"red"}>Not Published</Tag>
          )}
        </Space>
      ),
    },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => {
              setshowModel(!isOpen);
              setEditable(true);
              editContent(record._id || record.id);
            }}
            className="table_pill_btn table_pill_btn--view"
            icon={<EditOutlined />}
          >
            Edit
          </Button>
          <Popover
            content={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <Button
                  style={{
                    backgroundColor: "green",
                    width: "100%",
                    color: "#fff",
                  }}
                  onDoubleClick={() => deleteOtherContent(record._id || record.id)}
                >
                  Yes
                </Button>
              </div>
            }
            title="Please Double click to delete."
          >
            <Button
              className="table_pill_btn table_pill_btn--danger"
              icon={<DeleteOutlined />}
            >
              Delete
            </Button>
          </Popover>
        </Space>
      ),
    },
  ];

  return (
    <div className="dataTable">
      <div className="filterMenu">
        {contentType === "womeninsports" && (
          <Button onClick={showModal} className="add_button">
            Add New Women In Sport
          </Button>
        )}
        {contentType === "crisis" && (
          <Button onClick={showModal} className="add_button">
            Add New Crisis Management
          </Button>
        )}
        {contentType === "newsonwellness" && (
          <Button onClick={showModal} className="add_button">
            Add New News On Wellness
          </Button>
        )}
        {contentType === "takeaway" && (
          <Button onClick={showModal} className="add_button">
            Add New Takeaway
          </Button>
        )}

        <Input.Search
          onSearch={(value) => {
            setSearchText(value);
          }}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          className="searchField"
          placeholder="Search here..."
        />
      </div>
      <AppTable
        className="dataGrid"
        columns={columns}
        dataSource={contentData}
      />
    </div>
  );
}

export default DataTableOtherContent;
